import ButtonSimple from '../buttons/ButtonSimple';

export default class OverlayEndScreen extends Phaser.Group {
  constructor(game) {
    super(game);

    this.onClose = new Phaser.Signal();

    // background
    const bg = this.game.make.image(0, 0, 'bg_location_' + this.game.controller.location);
    this.addChild(bg);

    // replay
    this.btnReplay = new ButtonSimple({
      game: this.game,
      up: 'btn_continue',
      over: 'btn_continue',
      atlas: 'ui_buttons',
    });
    this.btnReplay.x = this.game.defaultWidth / 2 + 140;
    this.btnReplay.y = 360;
    this.addChild(this.btnReplay);
    this.btnReplay.onInputDown.addOnce(this.handleTapReplay, this);
    this.btnReplay.scale.set(0);
    this.game.add.tween(this.btnReplay.scale).to({ x: 1, y: 1 }, 300, Phaser.Easing.Back.Out, true);

    // home
    this.btnHome = new ButtonSimple({
      game: this.game,
      up: 'btn_home',
      over: 'btn_home',
      atlas: 'ui_buttons',
    });
    this.btnHome.x = this.game.defaultWidth / 2 - 130;
    this.btnHome.y = 360;
    this.addChild(this.btnHome);
    this.btnHome.onInputDown.addOnce(this.handleTapHome, this);
    this.btnHome.scale.set(0);
    this.game.add
      .tween(this.btnHome.scale)
      .to({ x: 1, y: 1 }, 300, Phaser.Easing.Back.Out, true, 100);

    // elinor
    this.elinor = this.game.make.image(0, this.game.height, 'ui_player_mode', 'elinor');
    this.elinor.anchor.set(1, 1);
    this.addChild(this.elinor);

    this.positionElements();
  }

  positionElements() {
    this.elinor.x = this.game.defaultWidth - (this.game.defaultWidth - this.game.width) * 0.5 - 50;
  }

  removeListeners() {
    this.btnReplay.onInputDown.remove(this.handleTapReplay, this);
    this.btnHome.onInputDown.remove(this.handleTapHome, this);
  }

  handleTapReplay() {
    this.removeListeners();
    this.game.controller.replayTwoPlayers();
  }

  handleTapHome() {
    this.removeListeners();
    this.game.controller.showWelcomeScreen();
  }

  destroy() {
    this.removeListeners();
    this.btnHome = null;
    this.btnReplay = null;

    super.destroy();
  }
}
